(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bw-interactive-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
    const range = (value, start, end) => {
      const point = clamp((value - start) / (end - start), 0, 1);
      return point * point * (3 - (2 * point));
    };
    const initialize = (section) => {
      if (section.dataset.bwReady === 'true') return;
      section.dataset.bwReady = 'true';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        section.dataset.bwReduced = 'true';
        return;
      }
      let frame = 0;
      const intensity = Number(section.dataset.intensity || .7);
      const render = () => {
        frame = 0;
        const rect = section.getBoundingClientRect();
        const distance = Math.max(1, section.offsetHeight - window.innerHeight);
        const progress = clamp(-rect.top / distance, 0, 1);
        const cutOne = range(progress, .02, .18);
        const cutTwo = range(progress, .15, .32);
        const cutThree = range(progress, .29, .46);
        const unveil = range(progress, .43, .61);
        const mark = range(progress, .5, .69);
        const copy = range(progress, .67, .83);
        const cta = range(progress, .81, .92);
        const exit = range(progress, .95, 1);
        const adjusted = .82 + (intensity * .25);
        section.style.setProperty('--bw-progress', progress.toFixed(4));
        section.style.setProperty('--bw-cut-one', (cutOne * adjusted).toFixed(4));
        section.style.setProperty('--bw-cut-two', (cutTwo * adjusted).toFixed(4));
        section.style.setProperty('--bw-cut-three', (cutThree * adjusted).toFixed(4));
        section.style.setProperty('--bw-unveil', unveil.toFixed(4));
        section.style.setProperty('--bw-mark', mark.toFixed(4));
        section.style.setProperty('--bw-copy', copy.toFixed(4));
        section.style.setProperty('--bw-cta', cta.toFixed(4));
        section.style.setProperty('--bw-exit', exit.toFixed(4));
      };
      const requestRender = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(render);
      };
      window.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', requestRender, { passive: true });
      render();
    };
    const initializeAll = () => {
      document.querySelectorAll('[data-bw-forge]').forEach(initialize);
    };
    initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
